import { ProjectEnvironment } from "../../../roofsafetymanagement-library/src/public-api";



export const environment: ProjectEnvironment = {
    production: true,

    apiUri: "https://itdoc.definitiv-ds.de/server/itdoc.definitiv-ds.de",
    appUserUri: "https://itdoc.definitiv-ds.de/Server/auth.futura.definitiv-ba.de/public",  
    baseHref: "https://itdoc.definitiv-ds.de",

    clientId: "itdoc",

    toolbarImage: "assets\\images\\def_logo_klein_white.png",

    version: "2.0 Dev",

    agbLink: "/agb",
    privacyLink: "/datenschutz",
    imprintLink: "/impressum",
    priceLink: "",
    nfcLogin: false,
    userRegistration: false,

    showLanguageSelection: false,

    vapidPublicKey: "BKaOhrym5m_NBkfol1hkeLGUSdyoHcRCmSldBBx27okwX_6g2X3kqVa57ezRie9ecOGB6QKLuM3uK4ga7VsDRVo"

};

